import { Reveal, Eyebrow } from "./Reveal";

const POINTS = [
  "Natural-looking skin",
  "Makeup that photographs beautifully",
  "Looks tailored to your features",
  "A curated kit of luxury, skin-first products",
  "Long-lasting, event-ready makeup",
  "A calm & personalized experience",
];

export const Why = () => (
  <section id="why" data-testid="section-why-mrinalee" className="py-24 sm:py-32 bg-[#F4EBDD]">
    <div className="max-w-5xl mx-auto px-5 sm:px-8">
      <Reveal className="mb-14">
        <Eyebrow index="06">Why Mrinalee</Eyebrow>
        <h2 className="font-serif-ed font-normal text-3xl sm:text-4xl lg:text-5xl mt-6 text-[#2A1F16]">
          Quiet details, <em className="text-[#96754D]">lasting impression</em>
        </h2>
      </Reveal>

      <div className="border-t border-[#E9DCC8]">
        {POINTS.map((p, i) => (
          <Reveal key={p} delay={i * 0.07}>
            <div
              data-testid={`why-point-${i + 1}`}
              className="group flex items-baseline gap-6 sm:gap-10 py-6 sm:py-7 border-b border-[#E9DCC8]"
            >
              <span className="font-serif-ed italic text-[#B8893B] text-lg w-10 shrink-0">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="font-serif-ed font-normal text-2xl sm:text-3xl lg:text-4xl text-[#2A1F16] group-hover:translate-x-2 group-hover:text-[#96754D] transition-[transform,color] duration-500">
                {p}
              </span>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
